mutation UpdateCharityContact($input: UpdateCharityContactInput!) {
  updateCharityContact(input: $input) {
    success
  }
}
